export class MdocsSafteymodel{
    Safteyid:number;
    Path:string;
    Title:string;
    Description:string;
    Status:boolean;
    UnitID:number;
    CreatedDate:Date;
}